require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./i-have-not-failed.json") })
        }
      }, "path---i-have-not-failed");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---i-have-not-failed!./.cache/json/i-have-not-failed.json
// module id = 829
// module chunks = 231608221292675